import React, { useEffect, useState } from "react";
import { hasPermission } from "../utils/auth";
import { ThemeProvider } from "@mui/material/styles";
import Table_theme from "../Themes/TableTheme";
import MainLayout from "../Themes/MainLayout";
import FormThemes from "../Themes/FormThemes";
import {
  Box,
  Typography,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  TextField,
  OutlinedInput,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CssBaseline,
  Snackbar,
  Alert,
} from "@mui/material";
import { useCurrentUser } from "../utils/useCurrentUser";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getCurrentMonth = () => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  return `${yyyy}-${mm}`; // format: "YYYY-MM"
};

const PayslipDownload = () => {
  const { userId, empId, boId, roles, hasPermission } = useCurrentUser();
  const [empName, setEmpName] = useState({});
  const [employees, setEmployees] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [openError, setOpenError] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());
  const [monthError, setMonthError] = useState("");
  useEffect(() => {
    if (empId) {
      setSelectedEmp(empId);
    }
  }, [empId]);
  // Fetch employee list
  useEffect(() => {
    fetch(`${BASE_URL}/api/employees/${boId}`) // adjust if needed
      .then((res) => res.json())
      .then((data) => setEmployees(data || []))
      .catch((err) => console.error("Failed to fetch employees:", err));
  }, []);

  const downloadPayslip = async () => {
    // Validate month field
    const parts = (selectedMonth || "").split("-");
    const year = parts[0] || "";
    const month = parts[1] || "";
    const hasYear = year.length === 4 && !isNaN(year);
    const hasMonth = month.length === 2 && !isNaN(month);

    if (!hasYear && !hasMonth) {
      setMonthError("Please select a month and year");
      return;
    } else if (!hasYear) {
      setMonthError("Please select a year");
      return;
    } else if (!hasMonth) {
      setMonthError("Please select a month");
      return;
    }
    setMonthError("");
    try {
      const res = await fetch(
        `${BASE_URL}/payslip/generate-payslip/${selectedEmp}/${selectedMonth}`
      );
      if (!res.ok) throw new Error("Payslip not available");

      const cloned = res.clone();
      const text = await cloned.text();
      console.log("PDF response preview:", text.slice(0, 100));
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Payslip-${selectedEmp}-${selectedMonth}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      setErrorMsg("Payslip not available for the selected month.");
      setOpenError(true);
    }
  };

  useEffect(() => {
    const fetchLoginUser = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/checkin/${empId}/${boId}`);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const data = await res.json();
        console.log("API Response:", data);

        if (data.length > 0) {
          setEmpName(data[0]); // store first object instead of whole array
        }
      } catch (err) {
        console.error("Failed to fetch employee details", err);
      }
    };

    fetchLoginUser();
  }, [empId]);

  return (
    <MainLayout>
    <ThemeProvider theme={FormThemes}>
      <CssBaseline />
      <Box sx={{ width: "100%", overflowX: "auto", px: 0, py: 2, mt: "-40px" }}>


        <Grid container spacing={3} mt={2}>
          <Grid item xs={12} md={4} display="flex" alignItems="center">
            <TextField
              fullWidth
              label="Employee"
              value={empName?.employee_name || ""}
              InputProps={{
                readOnly: true, // makes it non-editable
              }}
              sx={{ minWidth: 250 }}
            />
          </Grid>
          <Grid item xs={12} md={4} display="flex" alignItems="center">
            <TextField
              label="Month (MM-YYYY)"
              type="month"
              fullWidth
              value={selectedMonth}
              onChange={(e) => {
                setSelectedMonth(e.target.value);
                setMonthError("");
              }}
              InputLabelProps={{ shrink: true }}
              error={!!monthError}
              helperText={monthError || ""}
            />
          </Grid>
          <Grid item xs={12} md={4} display="flex" alignItems="center">
            <Button
              variant="contained"
              color="primary"
              onClick={downloadPayslip}
              //  disabled={!selectedEmp || !selectedMonth}
              fullWidth
            >
              Download Payslip
            </Button>
          </Grid>
        </Grid>
      </Box>
      {/* </Container> */}
      {/* Snackbar message */}
      <Snackbar
        open={openError}
        autoHideDuration={4000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMsg}
        </Alert>
      </Snackbar>
    </ThemeProvider>
    </MainLayout>
  );
};
export default PayslipDownload;
